/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck bender-url isn't supported in TypeScript yet
import { COMMERCE } from 'self-service-api/constants/EnrolledProductLines';
import { ENTERPRISE, PROFESSIONAL, STARTER } from 'self-service-api/constants/ProductLevels';
import { CMS, MARKETING, OPERATIONS, SALES, SERVICE } from 'self-service-api/constants/ProductLines';
import { NavItemEnum } from '../routing/NavItems';
import MARKETING_HUB_ICON from 'bender-url!pricing-pages-ui-components/js/productIcon/inbound/MarketingHub.svg';
import SALES_HUB_ICON from 'bender-url!pricing-pages-ui-components/js/productIcon/inbound/SalesHub.svg';
import SERVICE_HUB_ICON from 'bender-url!pricing-pages-ui-components/js/productIcon/inbound/ServiceHub.svg';
import CONTENT_HUB_ICON from 'bender-url!pricing-pages-ui-components/js/productIcon/inbound/ContentHub.svg';
import DATA_HUB_ICON from 'bender-url!pricing-pages-ui-components/js/productIcon/inbound/DataHub.svg';
import COMMERCE_HUB_ICON from 'bender-url!pricing-pages-ui-components/js/productIcon/inbound/CommerceHub.svg';
import SMART_CRM_ICON from 'bender-url!pricing-pages-ui-components/js/productIcon/inbound/SmartCrm.svg';
import BREEZE_INTELLIGENCE_ICON from 'bender-url!pricing-pages-lib/images/productIcons/BreezeIntelligence.svg';
import MARKETING_HUB_ICON_LEGACY from 'bender-url!pricing-pages-ui-components/js/productIcon/images/MarketingHub.svg';
import MARKETING_HUB_ENT_ICON from 'bender-url!pricing-pages-ui-components/js/productIcon/images/MarketingHub_Ent.svg';
import MARKETING_HUB_PRO_ICON from 'bender-url!pricing-pages-ui-components/js/productIcon/images/MarketingHub_Pro.svg';
import MARKETING_HUB_STARTER_ICON from 'bender-url!pricing-pages-ui-components/js/productIcon/images/MarketingHub_Starter.svg';
import SALES_HUB_ICON_LEGACY from 'bender-url!pricing-pages-ui-components/js/productIcon/images/SalesHub.svg';
import SALES_HUB_ENT_ICON from 'bender-url!pricing-pages-ui-components/js/productIcon/images/SalesHub_Ent.svg';
import SALES_HUB_PRO_ICON from 'bender-url!pricing-pages-ui-components/js/productIcon/images/SalesHub_Pro.svg';
import SALES_HUB_STARTER_ICON from 'bender-url!pricing-pages-ui-components/js/productIcon/images/SalesHub_Starter.svg';
import SERVICE_HUB_ICON_LEGACY from 'bender-url!pricing-pages-ui-components/js/productIcon/images/ServiceHub.svg';
import SERVICE_HUB_ENT_ICON from 'bender-url!pricing-pages-ui-components/js/productIcon/images/ServiceHub_Ent.svg';
import SERVICE_HUB_PRO_ICON from 'bender-url!pricing-pages-ui-components/js/productIcon/images/ServiceHub_Pro.svg';
import SERVICE_HUB_STARTER_ICON from 'bender-url!pricing-pages-ui-components/js/productIcon/images/ServiceHub_Starter.svg';
import CONTENT_HUB_ICON_LEGACY from 'bender-url!pricing-pages-ui-components/js/productIcon/images/ContentHub.svg';
import CONTENT_HUB_ENT_ICON from 'bender-url!pricing-pages-ui-components/js/productIcon/images/ContentHub_Ent.svg';
import CONTENT_HUB_PRO_ICON from 'bender-url!pricing-pages-ui-components/js/productIcon/images/ContentHub_Pro.svg';
import CONTENT_HUB_STARTER_ICON from 'bender-url!pricing-pages-ui-components/js/productIcon/images/ContentHub_Starter.svg';
import OPERATIONS_HUB_ICON_LEGACY from 'bender-url!pricing-pages-ui-components/js/productIcon/images/DataHub.svg';
import OPERATIONS_HUB_ENT_ICON from 'bender-url!pricing-pages-ui-components/js/productIcon/images/DataHub_Ent.svg';
import OPERATIONS_HUB_PRO_ICON from 'bender-url!pricing-pages-ui-components/js/productIcon/images/DataHub_Pro.svg';
import OPERATIONS_HUB_STARTER_ICON from 'bender-url!pricing-pages-ui-components/js/productIcon/images/DataHub_Starter.svg';
import COMMERCE_HUB_ICON_LEGACY from 'bender-url!pricing-pages-ui-components/js/productIcon/images/CommerceHub.svg';
import SMART_CRM_ICON_LEGACY from 'bender-url!pricing-pages-ui-components/js/productIcon/images/SmartCrm.svg';
import SMART_CRM_ENT_ICON from 'bender-url!pricing-pages-ui-components/js/productIcon/images/SmartCrm_Ent.svg';
import SMART_CRM_PRO_ICON from 'bender-url!pricing-pages-ui-components/js/productIcon/images/SmartCrm_Pro.svg';
export const ProductIconMap = {
  [MARKETING]: MARKETING_HUB_ICON_LEGACY,
  [SALES]: SALES_HUB_ICON_LEGACY,
  [SERVICE]: SERVICE_HUB_ICON_LEGACY,
  [CMS]: CONTENT_HUB_ICON_LEGACY,
  [OPERATIONS]: OPERATIONS_HUB_ICON_LEGACY,
  [COMMERCE]: COMMERCE_HUB_ICON_LEGACY,
  [NavItemEnum.BREEZE_INTELLIGENCE]: BREEZE_INTELLIGENCE_ICON,
  [NavItemEnum.SMART_CRM]: SMART_CRM_ICON_LEGACY,
  [NavItemEnum.HUBSPOT_CREDITS]: BREEZE_INTELLIGENCE_ICON
};
export const ProductIconMapInbound = {
  [MARKETING]: MARKETING_HUB_ICON,
  [SALES]: SALES_HUB_ICON,
  [SERVICE]: SERVICE_HUB_ICON,
  [CMS]: CONTENT_HUB_ICON,
  [OPERATIONS]: DATA_HUB_ICON,
  [COMMERCE]: COMMERCE_HUB_ICON,
  [NavItemEnum.SMART_CRM]: SMART_CRM_ICON
};
export const ProductTierIconMap = {
  [MARKETING]: {
    [STARTER]: MARKETING_HUB_STARTER_ICON,
    [PROFESSIONAL]: MARKETING_HUB_PRO_ICON,
    [ENTERPRISE]: MARKETING_HUB_ENT_ICON
  },
  [SALES]: {
    [STARTER]: SALES_HUB_STARTER_ICON,
    [PROFESSIONAL]: SALES_HUB_PRO_ICON,
    [ENTERPRISE]: SALES_HUB_ENT_ICON
  },
  [SERVICE]: {
    [STARTER]: SERVICE_HUB_STARTER_ICON,
    [PROFESSIONAL]: SERVICE_HUB_PRO_ICON,
    [ENTERPRISE]: SERVICE_HUB_ENT_ICON
  },
  [CMS]: {
    [STARTER]: CONTENT_HUB_STARTER_ICON,
    [PROFESSIONAL]: CONTENT_HUB_PRO_ICON,
    [ENTERPRISE]: CONTENT_HUB_ENT_ICON
  },
  [OPERATIONS]: {
    [STARTER]: OPERATIONS_HUB_STARTER_ICON,
    [PROFESSIONAL]: OPERATIONS_HUB_PRO_ICON,
    [ENTERPRISE]: OPERATIONS_HUB_ENT_ICON
  },
  [NavItemEnum.SMART_CRM]: {
    [PROFESSIONAL]: SMART_CRM_PRO_ICON,
    [ENTERPRISE]: SMART_CRM_ENT_ICON
  }
};